<div class="product-box">
    <div class="img-wrapper">
        <div class="lable-block">
            <span class="lable3" *ngIf='product?.newItem' i18n="@@New">New</span>
            <!-- <span class="lable4" *ngIf='product?.sale' i18n="@@ReducedPrice">Reduced price</span> -->
        </div>
        <div class="front">
            <a [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}">
                <img *ngIf="primaryImage" [attr.src]="primaryImage" style="max-width: 100%;max-height: 100%"
                    onError="handleError($event)" class="img-fluid">
                <!-- <img *ngIf="!primaryImage"  src="assets/images/img-not-available.png" class="img-fluid"> -->
            </a>
        </div>
        <!-- <ul class="product-thumb-list">
            <li class="grid_thumb_img" [ngClass]="{'active': selectedItem == variant.images}" *ngFor="let variant of product.variants">
                <a [routerLink]="" (click)="changeVariantImage(variant.images)">
                    <img [src]="variant.images">
                </a>
            </li>
        </ul> -->
        <div class="cart-info cart-wrap">
            <a [routerLink]="[]" [attr.data-target]="'#addtocart'+product?.id" data-toggle="modal"
                (click)="addToCart(product)" data-placement="left" title="Add to cart">
                <mat-icon svgIcon="heart"> </mat-icon>
            </a>
            <!-- <a [routerLink]="" (click)="addToWishlist(product)" title="Dodaj u listu želja">
                <mat-icon svgIcon="heart"> </mat-icon>
            </a> -->
            <!-- <a [routerLink]="" [attr.data-target]="'#quick-view'+product?.id" data-toggle="modal" title="Quick View">
                <mat-icon svgIcon="heart"> </mat-icon>
            </a> -->
            <!-- <a [routerLink]="['/home/compare']" (click)="addToCompare(product)" title="Dodaj u poređenje">
                <mat-icon svgIcon="heart"> </mat-icon>
            </a> -->
        </div>

        <div class="product-detail">
            <div style="height: 100%;">
                <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
                <a [routerLink]="['/home/left-sidebar/product', product?.id]">
                    <h6>{{product.name}}</h6>
                </a>
                <h4>
                    {{product?.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol'}}
                    <del>
                        <span class="money">{{product?.sale_price_without_tax?.amount |
                            currency:product?.sale_price_without_tax?.currency:'symbol'}}</span>
                    </del>
                </h4>
                <!-- <ul class="color-variant">
        <li [class]="variant.color" (click)="changeVariantImage(variant.images)" *ngFor="let variant of product.variants"></li>
      </ul> -->
            </div>
        </div>
    </div>
</div>